import { render, staticRenderFns } from "./Poste.vue?vue&type=template&id=25bed446&scoped=true"
import script from "./Poste.vue?vue&type=script&lang=js"
export * from "./Poste.vue?vue&type=script&lang=js"
import style0 from "./Poste.vue?vue&type=style&index=0&id=25bed446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bed446",
  null
  
)

export default component.exports